"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeHTML = void 0;
const tslib_1 = require("tslib");
const dompurify_1 = tslib_1.__importDefault(require("dompurify"));
class HTMLUtils {
    /**
     * If we use innerHTML then make sure we sanitize the html first
     * @param dirtyHTML any innerHTML whether it is clean or dirty, always sanitize dangerous operations
     * @param config add additional parameters to config
     */
    static sanitizeHTML(dirtyHTML, config) {
        const clean = dompurify_1.default.sanitize(dirtyHTML, Object.assign({
            ADD_ATTR: [...HTMLUtils.CUSTOM_TAS_ATTR, ...HTMLUtils.A_TARGET]
        }, config));
        if (window.dev) {
            const removed = dompurify_1.default.removed;
            if (removed?.length) {
                console.log("Removed", removed);
            }
        }
        return clean;
    }
    /**
     * Use this method for deprecated sanitations so that it doesn't show up when searching innerHTML
     * @param element The HTMLElement that will set innerHTML
     * @param dirtyHTML the dirtyHTML to be sanitized
     * @param config add additional parameters to config
     */
    static setSanitizedHTML(element, dirtyHTML, config) {
        element.innerHTML = HTMLUtils.sanitizeHTML(dirtyHTML, config);
    }
}
// https://github.com/cure53/DOMPurify/issues/317
// DOMPurify.addHook('afterSanitizeAttributes', function (node) {
//     // set all elements owning target to target=_blank
//     if ('target' in node) {
//         node.setAttribute('target', '_blank');
//         node.setAttribute('rel', 'noopener');
//     }
// });
HTMLUtils.CUSTOM_TAS_ATTR = ["mandatory", "minRows", "initialRows", "x-type", "enable-if"];
HTMLUtils.A_TARGET = ["target"]; // this might be a security issue. We can also add hooks after afterSanitizeAttributes
exports.default = HTMLUtils;
function encodeHTML(unsafe) {
    return new XMLSerializer().serializeToString(document.createTextNode(unsafe));
}
exports.encodeHTML = encodeHTML;
//# sourceMappingURL=HTMLUtils.js.map